module.exports = __webpack_public_path__ + "teqbahn-assets/media/31.6b661783.png";